<template>
  <v-dialog v-model="dialog" max-width="900px">
    <v-card class="confirm-modal">
      <v-row no-gutters align="center" class="modal-header">
        <v-col>
          <div class="modal-title">Active</div>
        </v-col>
      </v-row>

      <v-card-text class="modal-content">
        <div v-for="(item, index) in selectedItemsFormatted" :key="index" class="data-row">
          <div class="row-number">
            {{ index + 1 }}
          </div>

          <div class="document-text">
            {{ item.document_id }}
          </div>

          <div class="document-id">
            {{ item.approver_cs }}
          </div>

          <div>
            <span class="service-badge">
              {{ item.group_service }}
            </span>
          </div>

          <div class="money text-right">
            {{ item.actual }}
          </div>
        </div>

        <div v-if="!selectedItemsFormatted.length" class="empty-data">
          <v-icon size="35" color="#b0b8c4">mdi-database-outline</v-icon>
          <div>ไม่พบรายการข้อมูล</div>
        </div>
      </v-card-text>

      <v-card-actions v-if="permission === true" class="modal-footer">
        <v-btn @click="confirmActive(selectedItemsFormatted)" color="#0EC62B3D" class="btn-confirm" depressed>
          <v-icon color="#008000" left small>mdi-check-bold</v-icon>
          ยืนยัน
        </v-btn>

        <v-btn @click="closeDialog" color="#E994948C" class="btn-cancel" depressed>
          <v-icon color="#ff0000" left small>mdi-close-thick</v-icon>
          ยกเลิก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      permission: false,
      selectedItemsFormatted: [
        {
          _id: "",
          document_id: "",
          approver_cs: "",
          group_service: "",
          actual: ""
        }
      ]
    };
  },

  methods: {
    open(data) {
      this.getPermissionApprover();
      this.selectedItemsFormatted = [
        {
          _id: data?._id || "",
          document_id: data?.document_id || "",
          approver_cs: data?.approver_cs || "",
          group_service: data?.group_service || "",
          actual: data?.actual || ""
        }
      ];
    },

    async getPermissionApprover() {
      try {
        const response = await this.axios.get(`${this.$api_url}/cs_to_po/api/v1/permission_approve`);
        this.permission = response.data.data.permission;
      } catch (error) {
        console.error("getApprover error:", error.response ? error.response.data : error);
      } finally {
        this.dialog = true;
      }
    },

    async confirmActive(data) {
      try {
        const transactionIds = data.map(item => item._id).filter(id => id);

        if (!transactionIds.length) {
          return;
        }

        const body = {
          transaction_id: transactionIds
        };
        const response = await this.axios.put(`${this.$api_url}/cs_to_po/api/v1/update_approver`, body);
        if (response.data && response.data.message) {
          this.alert("อนุมัติเอกสารสำเร็จ", "Success", "success");
          this.dialog = false;
          window.location.reload();
        }
      } catch (error) {
        console.error("update_approver error:", error.response ? error.response.data : error);
        return this.alert("ไม่สามารถอนุมัติเอกสารได้", "Fail", "error");
      }
    },

    closeDialog() {
      this.dialog = false;
    },

    alert(title = "", text = "Fail", icon = "info") {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: `<b class="alert-success-title">${title}</b>`,
        text: text,
        showClass: {
          popup: "animate-show-card"
        },
        customClass: {
          container: "alert-card-block",
          popup: "alert-card-success",
          title: "alert-title-block",
          htmlContainer: "alert-text-box",
          icon: "alert-icon"
        }
      });
    }
  }
};
</script>

<style scoped>
.confirm-modal {
  border-radius: 14px !important;
  font-family: 'Noto Sans Thai', sans-serif !important;
  overflow: hidden !important;
  background: #ffffff !important;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.16) !important;
}

.modal-header {
  min-height: 58px;
  padding: 14px 22px;
  background: linear-gradient(135deg, #f8fbff 0%, #ffffff 100%);
  border-bottom: 1px solid #edf1f5;
}

.modal-title {
  font-size: 19px;
  font-weight: 700;
  color: #172033;
  line-height: 28px;
}

.modal-content {
  max-height: 55vh;
  overflow-y: auto;
  padding: 18px 22px !important;
  background: #ffffff;
}

.modal-content::-webkit-scrollbar {
  width: 5px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #d4d9e1;
  border-radius: 10px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #b9c0cb;
}

.data-row {
  display: grid;
  grid-template-columns: 40px minmax(150px, 1.2fr) minmax(150px, 1.3fr) minmax(150px, 1.5fr) 110px;
  gap: 14px;
  align-items: center;
  min-height: 52px;
  padding: 8px 13px;
  margin-bottom: 7px;
  background: #ffffff;
  border: 1px solid #edf0f4;
  border-radius: 10px;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.data-row:last-child {
  margin-bottom: 0;
}

.data-row:hover {
  background: #f9fbff;
  border-color: #dbe7f5;
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.row-number {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eef5ff;
  color: #0b68d6;
  font-size: 12px;
  font-weight: 700;
}

.document-text {
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #263247;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-id {
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: #687386;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.service-badge {
  display: inline-block;
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 7px;
  background: #f2f7ff;
  color: #2367b1;
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.money {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
}

.text-right {
  text-align: right;
}

.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 140px;
  color: #9aa4b2;
  font-size: 13px;
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 13px 22px 16px !important;
  border-top: 1px solid #edf0f4;
  background: #ffffff;
}

.btn-confirm,
.btn-cancel {
  width: 119px !important;
  height: 32px !important;
  min-height: 32px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  box-shadow: none !important;
  transition: all 0.18s ease;
}

.btn-confirm {
  color: #008000 !important;
  border: 1px solid #bce9cd;
}

.btn-confirm:hover {
  background-color: #eaf9ef !important;
  border-color: #9edbb5;
}

.btn-cancel {
  color: #ff0000 !important;
  border: 1px solid #f1c4c4;
}

.btn-cancel:hover {
  background-color: #fff3f3 !important;
  border-color: #e6aaaa;
}

@media (max-width: 700px) {
  .confirm-modal {
    border-radius: 12px !important;
  }

  .modal-header {
    min-height: 52px;
    padding: 13px 16px;
  }

  .modal-title {
    font-size: 18px;
  }

  .modal-content {
    max-height: 60vh;
    padding: 13px !important;
  }

  .data-row {
    display: grid;
    grid-template-columns: 32px minmax(0, 1fr);
    gap: 8px;
    padding: 11px;
  }

  .row-number {
    grid-row: span 4;
  }

  .document-text,
  .document-id,
  .service-badge,
  .money {
    text-align: left;
  }

  .service-badge {
    width: fit-content;
    max-width: 100%;
  }

  .modal-footer {
    padding: 12px !important;
    gap: 8px;
  }

  .btn-confirm,
  .btn-cancel {
    flex: 1;
    width: auto !important;
  }
}
</style>